// extracted by mini-css-extract-plugin
export default {"mainContainer":"NotFound_mainContainer__mlnre","errorNumber":"NotFound_errorNumber__15AJP","errorText":"NotFound_errorText__KyJwd","button":"NotFound_button__I3m-q"};